import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/thanks/thanks-banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>
                Your Journey to{" "}
                <span style={{ color: "#f47a14" }}> Innovation Starts </span>
                Here!
              </h1>
              <p>
                We appreciate your interest in TekRevol services. Your inquiry
                has been received and we are excited to help you explore and
                bring your vision to reality.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
